<template>
  <v-col>
    <v-btn
      absolute
      fab
      icon
      style="margin-top: 3em"
    >
      <v-icon x-large>
        mdi-plus-circle
      </v-icon>
    </v-btn>
    <vueDropzone
      id="dropzone"
      ref="myVueDropzone"
      :options="dropzoneOptions"
      width="800"
      class="pa-5"
      style="margin-bottom: 50px; background-color: #e3e3e3; border: dashed;"
      @vdropzone-file-added="add($event)"
    />
  </v-col>
</template>

<script>

import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  components: {
    vueDropzone
  },
  props: ['add'],
  data: () => ({
    dropzoneOptions: {
      url: 'https://httpbin.org/post',
      thumbnailWidth: 150,
      maxFilesize: 0.5,
      dictDefaultMessage: 'Drag and drop drawings on the screen or click to browse files',
      headers: { 'My-Awesome-Header': 'header value' }
    }
  })
};
</script>
